import React, {useState } from 'react';
import MediaQuery from 'react-responsive'
import Home1 from './Sections/Section1/Home1';
import Home2 from './Sections/Section2/Home2';
import Home3 from './Sections/Section3-2/Home3-2';
import Home4 from './Sections/Section4-2/Home4-2';
import Home5 from './Sections/Section5-2/Home5-2';
import Home7 from './Sections/Section3/Home3';
import Home8 from './Sections/Section8/Home8';
import Home9 from './Sections/Section9/Home9';
import Home10 from './Sections/Section10/Home10';
import Footer from '../Footer/Footer';

const Position = {
    TOP: 'top',
    BOTTOM: 'bottom',
    NONE: null,
};

const Section = {
    Section1: "Section 1",
    Section2: "Section 2",
    Section3: "Section 3",
    Section4: "Section 4",
    Section5: "Section 5",
    Section6: "Section 6",
    Section7: "Section 7",
    Section8: "Section 8",
    Section9: "Section 9",
    Section10: "Section 10",
    Footer: "Footer",
}

const Home = () => {
    const [sectionCurrently, setSectionCurrently] = useState(Section.Section1);
    const [positionCurrently, setPositionCurrently] = useState(Position.NONE);

    
    return (
        <>
                <Home1 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    setSectionCurrently = {setSectionCurrently}
                    setPositionCurrently = {setPositionCurrently}
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home2 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home3 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home4 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home5 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home7
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home8 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home9 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <Home10 
                    sectionCurrently = {sectionCurrently} 
                    positionCurrently = {positionCurrently} 
                    Section = {Section}
                    Position = {Position}
                    responsive = {true}
                />
                <MediaQuery maxWidth={900}>
                    <Footer
                        sectionCurrently = {sectionCurrently} 
                        positionCurrently = {positionCurrently} 
                        setSectionCurrently = {setSectionCurrently}
                        setPositionCurrently = {setPositionCurrently}
                        Section = {Section}
                        Position = {Position}
                        responsive = {true}
                    />
                </MediaQuery>
            
        </>
    );
};

export default Home;
